"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _Button = _interopRequireDefault(require("../Button"));

var MobileCta = function MobileCta(_ref) {
  var back = _ref.back,
      handleClick = _ref.handleClick,
      text = _ref.text,
      disabled = _ref.disabled,
      content = _ref.content;
  return _react["default"].createElement(_style.Container, null, _react["default"].createElement(_style.PaddingContainer, null, content || _react["default"].createElement(_react["default"].Fragment, null, back && _react["default"].createElement(_style.BackOption, null, back), _react["default"].createElement(_Button["default"], {
    disabled: disabled,
    handleClick: handleClick,
    width: back ? 180 : '100%',
    height: 48
  }, text))));
};

MobileCta.propTypes = {
  back: _propTypes["default"].shape({}),
  handleClick: _propTypes["default"].func,
  text: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  content: _propTypes["default"].node
};
MobileCta.defaultProps = {
  text: undefined,
  handleClick: undefined,
  back: null,
  disabled: false,
  content: undefined
};
var _default = MobileCta;
exports["default"] = _default;